import { motion } from "framer-motion";
import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { createUseStyles } from "react-jss";
import { QuestionStyleType } from "types";

const SMALL_NUMBER_LIMIT = 5;

export const ButtonNumber: React.FC<QuestionStyleType> = ({
  section,
  question,
  formValues,
  handleButtonRatingClick,
}) => {
  const smallAnswersNumber = useMemo(
    () => question.answers.length <= SMALL_NUMBER_LIMIT,
    [question.answers.length]
  );

  const classes = useStyles({ smallAnswersNumber });

  return (
    <div className="text-center">
      <Row className="flex-nowrap px-2 mb-2">
        {question.answers.map((answer, idx) => {
          return (
            <Col
              className="px-1"
              onClick={() =>
                handleButtonRatingClick(
                  section.sectionCode,
                  question.id,
                  answer,
                  question.answers.length
                )
              }
              key={idx}
            >
              <motion.div whileTap={{ scale: 0.93 }}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{
                    duration: 0.5,
                    delay: idx / 8,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className={`${classes.buttonRatingNumber} ${
                    formValues.find((q) => q.questionId === question.id)
                      ?.answer === answer
                      ? classes.selectedButton
                      : ""
                  }`}
                >
                  {answer}
                </motion.div>
              </motion.div>
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col className={`text-start ${classes.scoreDescription}`}>
          {`1 = ${
            question.lowestMeaning ? question.lowestMeaning : "Insoddisfacente"
          }`}
        </Col>
        <Col className={`text-end ${classes.scoreDescription}`}>
          {`${question.answers[question.answers.length - 1]} = ${
            question.highestMeaning ? question.highestMeaning : "Eccellente"
          }`}
        </Col>
      </Row>
    </div>
  );
};

const useStyles = createUseStyles({
  buttonRatingNumber: ({
    smallAnswersNumber,
  }: {
    smallAnswersNumber: boolean;
  }) => ({
    width: "100%",
    height: 50,
    fontSize: 18,
    display: "inline-block",
    border: "1px solid #D2D7ED",
    borderRadius: 5,
    alignContent: "center",
    fontWeight: 700,
    textAlign: "center",
    cursor: "pointer",
    userSelect: "none",
  }),
  selectedButton: {
    backgroundColor: "#EDEFF8",
  },
  scoreDescription: {
    fontSize: 14,
  },
});
